import React, { useEffect, useMemo, useState } from "react";
import check from "../../../assets/images/check.png";
import cross from "../../../assets/images/cross.png"
import { Loader } from "../../loader";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { claimStatus } from "../../auth/redux/store";
import Header from "../../layout/Header";
import {
  isTransferSuccess,
} from "../../../utils/paymentResponse";
import CustomModal from "../../modal";
import Award_Summary_Pop_Up_Hindi from "../../../assets/images/Post Award Summary Pop-Up_Hindi.png"
import Award_Summary_Pop_Up_Marathi from "../../../assets/images/Post Award Summary Pop-Up_Marathi.png"
import Award_Summary_Pop_Up_Telugu from "../../../assets/images/Post Award Summary Pop-Up_Telugu.png"

const formatDisplayAmount = (value) => {
  const n = Number(value);
  if (!Number.isFinite(n)) return null;
  return n % 1 === 0 ? String(n) : n.toFixed(2);
};

export const TransferSucces = () => {
  const { lang } = useParams();
  const [loading] = useState(false);
  const finalData = useSelector((state) => state?.finalresponse);
  const amount = useSelector((state) => state?.amount);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();


  useEffect(() => {
    dispatch(claimStatus(false));
  }, [dispatch]);

  useEffect(() => {
    if (!finalData || Object.keys(finalData).length === 0) return;
    if (!isTransferSuccess(finalData)) {
      navigate(`/${lang}/transferFailed`, { replace: true });
    }
  }, [finalData, lang, navigate]);

  const displayAmount = useMemo(() => {
    const fromApi =
      finalData?.amount ??
      finalData?.cashRewards ??
      finalData?.transferAmount ??
      amount;
    return formatDisplayAmount(fromApi) ?? "—";
  }, [amount, finalData]);

  const successMessage = useMemo(() => {
    return t("transferSuccessPage.message", { amount: displayAmount });
  }, [displayAmount, t]);

  const [showProceedModal, setShowProceedModal] = useState(false);


  useEffect(() => {
    // Open modal after 5 seconds
    const openTimer = setTimeout(() => {
      setShowProceedModal(true);

      // Close modal after another 5 seconds
      const closeTimer = setTimeout(() => {
        setShowProceedModal(false);
      }, 5000);

      // Cleanup close timer
      return () => clearTimeout(closeTimer);
    }, 5000);

    // Cleanup open timer
    return () => clearTimeout(openTimer);
  }, []);

  useEffect(() => {
    const style = document.createElement('style');
    style.textContent = `
                .modal-backdrop {
                  background-color: transparent !important;
                }
                .modal-backdrop.show {
                  opacity:1 !important;
                } 
                body{
                background-color:white !important;
                }
                .modal-content {
                  border-radius: 10px !important;
                  position:absolute !important;
                  bottom:-10px !important;
                  box-shadow:0px 0px 10px 0px rgba(0, 0, 0, 0.5) !important;
                  }
                  .modal-dialog{
                  margin:0px !important;
                  width:100% !important;
                  }
                  .modal-body{
                  margin-top:1rem;
                  }
                  
              `;
    document.head.appendChild(style);
    return () => {
      document.body.style.backgroundColor = '';
      document.head.removeChild(style);
    };
  }, []);


  let bannerLogoSrc;
  if (lang === 'hi') {
    bannerLogoSrc = Award_Summary_Pop_Up_Hindi;
  } else if (lang === 'mr') {
    bannerLogoSrc = Award_Summary_Pop_Up_Marathi;
  } else if (lang === 'kn') {
    bannerLogoSrc = Award_Summary_Pop_Up_Hindi;
  } else if (lang === 'te') {
    bannerLogoSrc = Award_Summary_Pop_Up_Telugu;
  } else if (lang === 'pa') {
    bannerLogoSrc = Award_Summary_Pop_Up_Hindi;
  } else if (lang === 'gu') {
    bannerLogoSrc = Award_Summary_Pop_Up_Hindi;
  } else if (lang === 'ta') {
    bannerLogoSrc = Award_Summary_Pop_Up_Hindi;
  } else if (lang === 'bn') {
    bannerLogoSrc = Award_Summary_Pop_Up_Hindi;
  } else if (lang === 'en') {
    bannerLogoSrc = Award_Summary_Pop_Up_Hindi;
  } else if (lang === 'or') {
    bannerLogoSrc = Award_Summary_Pop_Up_Hindi;
  } else if (lang === 'ma') {
    bannerLogoSrc = Award_Summary_Pop_Up_Hindi;
  }
  else {
    bannerLogoSrc = Award_Summary_Pop_Up_Hindi;
  }


  return (
    <>
      <Header />
      <div className="main">
        <div className="container p-0">
          {loading && <Loader />}
          <div className="card border-0">
            <div className="card-body px-2 pt-0 pb-2">
              <div className="px-4 py-2 mt-5 text-center">
                <img
                  src={check}
                  alt="Check"
                  className="img-fluid d-block m-auto LogoImg"
                />

                <h3 className="mb-4 mt-4 text-center font-extrabold text-secondaryColor">
                  ₹ {displayAmount}
                </h3>

                <h6 className="font-extrabold">
                  {t("transferSuccessPage.title")}
                </h6>
                <p className="mb-4">{successMessage}</p>

                <button
                  type="button"
                  className="btn btn-secondary btnshadow bottom-fixed-container"
                  onClick={() =>
                    navigate(`/${lang}/awardsummary`, {
                      state: { defaultTab: "successList" },
                    })
                  }
                >
                  {t("transferSuccessPage.proceedButton")}
                </button>
              </div>
            </div>
          </div>

          <CustomModal
            show={showProceedModal}
            onHide={() => setShowProceedModal(false)}
            title={
              <img src={cross} alt="cross" className="img-fluid crossIcon" onClick={() => setShowProceedModal(false)} />
            }
            content={
              <div>
                <h5 className='font-bold'>{t('CompleteProtection')}</h5>
                <p>{t('winexcitingprizes')}</p>
                <div className='mt-2'>
                  <img src={bannerLogoSrc} alt="Post Award Summary Pop-Up_Hindi" className="img-fluid" />
                </div>
              </div>
            }

          />


        </div>
      </div>
    </>
  );
};
